var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"id":"app","fluid":""}},[_c('dialogs-wrapper'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }